// extracted by mini-css-extract-plugin
export default {"pageHeader":"styles_pageHeader__5sbDo","inner":"styles_inner__bbgnU","titleWrapper":"styles_titleWrapper__9ffYu","after":"styles_after__iDq3Z","title":"styles_title__tKM6S"};